export default __webpack_public_path__ + "static/media/full-headshot-2021.5c46361b.jpg";